/**
 * Format date to MM/DD/YYYY (e.g. 03/01/2026 = March 1, 2026)
 */
export function formatDateMMDDYYYY(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) {
    if (typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) return date;
    return '';
  }
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${month}/${day}/${year}`;
}

/**
 * Convert to YYYY-MM-DD for HTML date input
 */
export function toInputDate(dateStr) {
  if (!dateStr) return '';
  if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateStr)) return dateStr;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
}

/**
 * Convert any date to MM/DD/YYYY for storage/display
 * YYYY-MM-DD from date input - parse without timezone
 */
export function toMMDDYYYY(dateStr) {
  if (!dateStr) return '';
  const isoMatch = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${month}/${day}/${year}`;
  }
  const slashMatch = String(dateStr).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const [, a, b, year] = slashMatch;
    const aNum = parseInt(a), bNum = parseInt(b);
    if (aNum > 12) return `${String(bNum).padStart(2,'0')}/${String(aNum).padStart(2,'0')}/${year}`;
    if (bNum > 12) return `${String(aNum).padStart(2,'0')}/${String(bNum).padStart(2,'0')}/${year}`;
    return dateStr;
  }
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return formatDateMMDDYYYY(d);
}

/**
 * Parse MM/DD/YYYY to Date for sorting
 */
export function parseMMDDYYYY(str) {
  if (!str) return new Date(0);
  const match = String(str).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (match) {
    const [, month, day, year] = match;
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
  return new Date(str);
}
